<template>
  <!-- 全局返回顶部按钮 -->
  <Transition name="fade">
    <div v-show="btnShow">
      <img src="../../assets/img/icons/icon-goTop.png" alt="" class="go-top" @click="backTop">
    </div>
  </Transition>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';

let timer = null;
const btnShow = ref(false);
const store = useStore();

onMounted(() => window.addEventListener('scroll', scrollToTop));

function scrollToTop() {
  // let pageLookHeight = document.documentElement.clientHeight || document.body.clientHeight;
  // let num = store.state.isMobile ? (pageLookHeight / 2) : (98 / windowWidth);
  let scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  if (scroll >= 20) {
    btnShow.value = true;
  } else {
    btnShow.value = false;
  }
}

function backTop() {
  clearInterval(timer);
  timer = setInterval(function () {
    let backTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    let speedTop = backTop / 5;
     if (document.documentElement.scrollTop) {
      document.documentElement.scrollTop = backTop - speedTop;
    } else if (document.body.scrollTop) {
      document.body.scrollTop = backTop - speedTop;
    }
    if (backTop === 0) {
      clearInterval(timer);
    }
    document.addEventListener("wheel", () => {
      clearInterval(timer)
    }, false)
  }, 30);
}
</script>

<style scoped>
.go-top {
  position: fixed;
  right: 2.5vw;
  bottom: 8.07291vw;
  width: 3.33333vw;
  cursor: pointer;
  z-index: 500;
}

@media screen and (max-width: 750px) {

  .go-top {
    right: 4.4vw;
    bottom: 13.33333vw;
    width: 13.7vw;
  }

}
</style>